import {useContext} from "react";
import FilterEventContext from "/context/filter/FilterContext";
import {useRouter} from "next/router";
import {SvgMaskMob, SvgMasks, SvgMaskTablet} from "/components/shared/SvgIcons";

export default function NoEventsView() {
    const {state, dispatch} = useContext(FilterEventContext);
    const router = useRouter();
    return (
        <div className='h-full flex justify-center items-center'>
            <div className='flex justify-center items-center gap-8 md:mt-12 2xl:mt-4'>
                <div className='flex justify-center'>
                    <div className='hidden 2xl:block'>{SvgMasks()}</div>
                    <div className='hidden md:block 2xl:hidden'>{SvgMaskTablet()}</div>
                    <div className='md:hidden'>{SvgMaskMob()}</div>
                </div>
                <p className='text-gray-dark font-light text-sm md:text-base'>Leider haben wir zu
                    Ihrer Auswahl <br/> keine
                    Vorstellungen gefunden.</p>
            </div>
        </div>
    );
}
